import { TextFieldStyled } from "../../shared/styles";
import { Box } from "@mui/material";
import { ModalV2 } from "../../shared/modal/modal";
import { useEffect, useState } from "react";
import {
  createContactAgenda,
  editContactAgenda,
} from "../../redux/actions/agenda.actions";
import { useDispatch } from "react-redux";

export const ModalCreateEditContact = ({
  open,
  handleClose,
  idContact = null,
  contactData,
  isEdit = false,
  userId,
}) => {
  const [contact, setContact] = useState(
    contactData || {
      nombre: "",
      apellido: "",
      email: "",
      walletadress: "",
      alias: "",
    }
  );

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isFormIncomplete =
    !contact.nombre ||
    !contact.email ||
    !contact.walletadress ||
    !contact.alias ||
    !isValidEmail(contact.email);

  const dispatch = useDispatch();

  function handleChangeContact(e) {
    setContact({ ...contact, [e.target.name]: e.target.value });
  }

  function handleCreateEditContact() {
    if (isEdit && idContact) {
      dispatch(editContactAgenda(idContact, contact, userId));
    } else {
      dispatch(createContactAgenda(contact, userId));
      setContact({
        nombre: "",
        apellido: "",
        email: "",
        walletadress: "",
        alias: "",
      });
    }
    handleClose(isEdit ? "editContact" : "createContact");
  }

  useEffect(() => {
    if (isEdit) {
      setContact(contactData);
    } else {
      setContact({
        nombre: "",
        apellido: "",
        email: "",
        walletadress: "",
        alias: "",
      });
    }
  }, [isEdit, contactData]);

  return (
    <ModalV2
      isOpen={open}
      title={isEdit ? "Edit contact" : "Create contact"}
      handleClose={() => handleClose(isEdit ? "editContact" : "createContact")}
      actionButtons={[
        {
          label: "Cancel",
          onClick: () => handleClose(isEdit ? "editContact" : "createContact"),
        },
        {
          label: isEdit ? "Edit" : "Create",
          onClick: handleCreateEditContact,
          disabled: isFormIncomplete,
          tooltipLabel: isFormIncomplete
            ? isValidEmail(contact.email) || !contact?.email
              ? "Fill required fields"
              : "Invalid email format"
            : "",
        },
      ]}
    >
      <Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={"20px"}
          mb={"24px"}
          px={"24px"}
        >
          <TextFieldStyled
            required
            name={"alias"}
            value={contact.alias}
            label={"Alias"}
            type={"text"}
            InputProps={{
              disableUnderline: true,
            }}
            onChange={handleChangeContact}
          />
          <TextFieldStyled
            required
            name={"nombre"}
            value={contact.nombre}
            label={"Name"}
            type={"text"}
            InputProps={{
              disableUnderline: true,
            }}
            onChange={handleChangeContact}
          />
          <TextFieldStyled
            name={"apellido"}
            value={contact.apellido}
            label={"Last name"}
            type={"text"}
            InputProps={{
              disableUnderline: true,
            }}
            onChange={handleChangeContact}
          />
          <TextFieldStyled
            required
            name={"email"}
            value={contact.email}
            label={"Email"}
            type={"email"}
            InputProps={{
              disableUnderline: true,
            }}
            onChange={handleChangeContact}
          />
          <TextFieldStyled
            required
            name={"walletadress"}
            value={contact.walletadress}
            label={"Wallet address"}
            type={"text"}
            InputProps={{
              disableUnderline: true,
            }}
            onChange={handleChangeContact}
          />
        </Box>
      </Box>
    </ModalV2>
  );
};
